import useHomeType from 'hooks/useHomeType'
import styled from 'styled-components'
import { RotaPatternView } from '../RotaPattern/RotaPatternView'

export const RotaViewVisitsScreen = () => {
  const { hasRota } = useHomeType()

  if (!hasRota) {
    return null
  }

  return (
    <PageContainer>
      <RotaPatternView type="visit" />
    </PageContainer>
  )
}

const PageContainer = styled.div`
  padding: 24px 48px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
`
